import request from '@utils/request'

export function fetchWithdrawList(params) {
  return request({
    url: '/admin/withdraw',
    method: 'get',
    params,
  })
}

export function fetchWithdraw(withdraw_seq) {
  return request.get(`/admin/withdraw/${withdraw_seq || 0}`)
}

export function fetchTransferList(params) {
  return request({
    url: '/admin/withdraw/transfer',
    method: 'get',
    params,
  })
}

export function fetchTransfer(transfer_seq) {
  return request.get(`/admin/withdraw/transfer/${transfer_seq || 0}`)
}

export function createTransfer(data) {
  return request.post('/admin/withdraw/transfer', data)
}

export function rejectWithdraw(withdraw_seq) {
  return request({
    url: `/admin/withdraw/${withdraw_seq}`,
    method: 'patch',
    data: {
      type: 'SET_REJECTED',
    },
  })
}

export function approveWithdraw(withdraw_seq) {
  return request({
    url: `/admin/withdraw/${withdraw_seq}`,
    method: 'patch',
    data: {
      type: 'SET_APPROVED',
    },
  })
}

export function fetchPolicies(params) {
  return request({
    url: `/admin/withdraw/policy`,
    params,
  })
}

export function fetchPolicy(seq) {
  return request({
    url: `/admin/withdraw/policy/${seq || 0}`,
    method: 'get',
  })
}

export function createPolicy(data) {
  return request.post('/admin/withdraw/policy', data)
}

export function updatePolicy(data) {
  return request.put(`/admin/withdraw/policy/${data.seq}`, data)
}

export function deletePolicy(seq) {
  return request.delete(`/admin/withdraw/policy/${seq}`)
}

export function fetchPolicyConditions(policy_seq) {
  return request({
    url: `/admin/withdraw/policy/${policy_seq || 0}/condition`,
  })
}

export function fetchPolicyCondition(policy_seq, seq) {
  return request({
    url: `/admin/withdraw/policy/${policy_seq || 0}/condition/${seq || 0}`,
    method: 'get',
  })
}

export function createPolicyCondition({ policy_seq, ...data }) {
  return request.post(
    `/admin/withdraw/policy/${policy_seq || 0}/condition/`,
    data
  )
}

export function updatePolicyCondition({ policy_seq, seq, ...data }) {
  return request.put(
    `/admin/withdraw/policy/${policy_seq || 0}/condition/${seq}`,
    data
  )
}

export function deletePolicyCondition(policy_seq, seq) {
  return request.delete(
    `/admin/withdraw/policy/${policy_seq || 0}/condition/${seq}`
  )
}
